import script from "./FixedFeesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedFeesTable.vue?vue&type=script&setup=true&lang=js"

import "./FixedFeesTable.vue?vue&type=style&index=0&id=2b33deac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b33deac"]])

export default __exports__